/* ============================================================
   19TH HOLE — THEME JS
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* ── HEADER SCROLL SHADOW ── */
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 40
        ? '0 4px 24px rgba(0,0,0,0.28)'
        : 'none';
    }, { passive: true });
  }

  /* ── MOBILE NAV TOGGLE ── */
  const toggle = document.querySelector('.site-header__mobile-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', isOpen);
      mobileNav.setAttribute('aria-hidden', !isOpen);
    });
  }

  /* ── PRODUCT GALLERY THUMBNAILS ── */
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const featuredImg = document.getElementById('product-featured-image');
  if (thumbs.length && featuredImg) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        featuredImg.src = thumb.dataset.src;
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  }

  /* ── PRODUCT OPTION SELECTORS ── */
  const optionValues = document.querySelectorAll('.product-option__value');
  const variantSelect = document.getElementById('variant-select');
  if (optionValues.length && variantSelect) {
    optionValues.forEach(btn => {
      btn.addEventListener('click', () => {
        const idx = btn.dataset.optionIndex;
        document.querySelectorAll(`.product-option__value[data-option-index="${idx}"]`)
          .forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        updateVariant();
      });
    });

    function updateVariant() {
      const selected = [];
      [0, 1, 2].forEach(i => {
        const active = document.querySelector(`.product-option__value[data-option-index="${i}"].active`);
        if (active) selected.push(active.dataset.value);
      });
      Array.from(variantSelect.options).forEach(opt => {
        if (selected.every(val => opt.text.includes(val))) {
          opt.selected = true;
        }
      });
    }
  }

  /* ── CART QUANTITY BUTTONS ── */
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.cart-item__qty').querySelector('.qty-input');
      let val = parseInt(input.value) + parseInt(btn.dataset.change);
      input.value = Math.max(0, val);
    });
  });

  /* ── FILTER TABS (collection page) ── */
  document.querySelectorAll('.filter-tab').forEach(tab => {
    tab.addEventListener('click', () => {
      document.querySelectorAll('.filter-tab').forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
    });
  });

});
